module.exports = "<div class=\"row no-gutters\">\r\n  <div class=\"col-2\">\r\n    <button (click)=\"removeFromCart()\" class=\"btn btn-secondary btn-block\">-</button>\r\n  </div>\r\n  <div class=\"col text-center\">\r\n    {{ shoppingCart.getQuantity(product) }} in cart\r\n  </div>\r\n  <div class=\"col-2\">\r\n    <button (click)=\"addToCart()\" class=\"btn btn-secondary btn-block\">+</button>\r\n  </div>\r\n\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/React/Antique/src/app/product-quantity/product-quantity.component.html
// module id = ../../../../../src/app/product-quantity/product-quantity.component.html
// module chunks = 1